export enum ProjectTypeEnum {
  PROJECT,
  COST_CENTER
}

export const mapProjectTypeToLabel = {
  [ProjectTypeEnum.PROJECT]: 'Proyecto',
  [ProjectTypeEnum.COST_CENTER]: 'Centro de Costo'
};
